export default __webpack_public_path__ + "static/article-tips-to-reduce-your-credit-card-interest-c7e93c5ad2c1c5f939ea0a6a3f97215f.jpg";